<template>
  <fo-layout>
    <div class="filter-input" ref="filter">
      <!-- <a-select class="item-input card-shadow" placeholder="Filter by industries" allowClear>
        <a-select-option value="jack"> Jack </a-select-option>
      </a-select>
      <a-select class="item-input card-shadow" placeholder="Filter by Practice" allowClear>
        <a-select-option value="jack"> Jack </a-select-option>
      </a-select>
      <a-select class="item-input card-shadow" placeholder="Filter by title" allowClear>
        <a-select-option value="jack"> Jack </a-select-option>
      </a-select> -->
      <industry v-model="memberCond.member_industry_id" @change="readItems"></industry>
      <areas v-model="memberCond.member_business_id" @change="readItems"></areas>
      <a-input-search class="item-input card-shadow" placeholder="输入姓名搜索"
        allowClear
        v-model="memberCond.keyword"
        @search="searchHandle" />
    </div>
    <div class="teama-card-list">
      <a-spin :spinning="loading">
        <a-row :gutter="30" v-if="memberData.length">
          <a-col :sm="8" v-for="(item, index) in memberData" :key="index">
            <div class="card-item card-shadow" @click="$router.push('./team/' + item.code)">
              <div class="back-mask primary-bg"><!-- 背景蒙板 --></div>
              <img class="back-logo" src="../../../static/logo1.png" alt="">
              <div class="name-photo">
                <div class="photo centerimage"
                  :style="'background-image: url(' + item.member_poster + ')'"></div>
                <div class="username">
                  <h1 class="black to-1">{{item.member_name}}</h1>
                  <p class="silver ht-30">{{item.member_title_name ? item.member_title_name : ''}}</p>
                </div>
              </div>
              <div class="item-info">
                <p class="silver">服务行业</p>
                <template v-for="(industry, indusInd) in item.member_industry">
                  <p class="black" :key="indusInd" v-if="indusInd < 2">{{industry}}</p>
                </template>
              </div>
              <div class="item-info">
                <p class="silver">业务领域</p>
                <template v-for="(business, busInd) in item.member_business">
                  <p class="black" :key="busInd" v-if="busInd < 2">{{business}}</p>
                </template>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="30" v-else>
          <a-col :sm="8" v-for="(item, index) in 3" :key="index">
            <div class="card-item card-shadow">
              <div class="back-mask primary-bg"><!-- 背景蒙板 --></div>
              <img class="back-logo" src="../../../static/logo1.png" alt="">
              <div class="name-photo">
                <div class="photo centerimage gray-bg"></div>
                <div class="username">
                  <h1 class="black to-1">
                    <span class="dis-bl ht-30 gray-bg wi-100 mb-10"></span>
                  </h1>
                  <p class="silver">
                    <span class="dis-bl ht-20 gray-bg wi-80"></span>
                  </p>
                </div>
              </div>
              <div class="item-info">
                <p class="silver">服务行业</p>
                <p class="black">
                  <span class="dis-bl ht-20 gray-bg wi-100"></span>
                  <span class="dis-bl ht-10"></span>
                  <span class="dis-bl ht-20 gray-bg wi-100"></span>
                </p>
              </div>
              <div class="item-info">
                <p class="silver">业务领域</p>
                <p class="black">
                  <span class="dis-bl ht-20 gray-bg wi-100"></span>
                  <span class="dis-bl ht-10"></span>
                  <span class="dis-bl ht-20 gray-bg wi-100"></span>
                </p>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-spin>
      <div class="pagination-style" v-if="memberData.length">
        <a-pagination
          :default-current="1"
          :total="memberTotal"
          :page-size="memberCond.page_size"
          @change='onCurrentPageChange' />
      </div>
    </div>
  </fo-layout>
</template>

<script>
import industry from './comps/selectedIndustry.vue'
import areas from './comps/selectedAreas.vue'
export default {
  components: {
    areas,
    industry
  },
  data () {
    return {
      // 保存客户数据
      memberData: [],
      // 客户总数
      memberTotal: 0,
      // 表格加载动画
      loading: false,
      // 客户查询条件
      memberCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 6,
        // 关键词搜索
        keyword: '',
        // 业务id
        member_business_id: undefined,
        // 行业id
        member_industry_id: undefined
      }
      // code...
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readItems()
    // code...
  },
  methods: {
    // readList () {
    //   this.loading = true
    //   this.get({
    //     url: 'articleRead',
    //     data: this.cond
    //   }, (res) => {
    //     this.loading = false
    //     this.data = res.data.items
    //     this.total = res.data.total
    //   })
    // },
    searchHandle () {
      this.memberCond.page_num = 1
      this.readItems()
    },
    /*
    * 换页事件
    */
    onCurrentPageChange (e) {
      window.scroll(0, (this.$refs.filter.offsetTop - 30))
      this.memberCond.page_num = e
      this.readItems()
    },
    /*
    * 查询客户
    */
    readItems () {
      this.loading = true
      this.get({
        url: 'memberRead',
        data: this.memberCond
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.memberTotal = r.data.total
          this.memberData = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>

<style lang="less">
  /*头像宽度*/
  @photoWidth: 80px;
  /*logo宽度*/
  @logoWidth: 160px;
  /*蒙板小方块宽度*/
  @maskWidth: 30px;
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  body {
    .filter-input {
      width: 100%;
      margin-bottom: 20px;
      .item-input {
        width: 100%;
        .anticon {
          font-size: 26px;
        }
      }
    }
  }
  .teama-card-list {
    .card-item {
      overflow: hidden;
      height: 330px;
      background-color: #FFF;
      padding: 30px;
      cursor: pointer;
      margin-bottom: 20px;
      position: relative;
      .back-logo {
        width: @logoWidth;
        height: @logoWidth;
        position: absolute;
        bottom: -30px;
        right: -30px;
      }
      .back-mask {
        width: @maskWidth;
        height: @maskWidth;
        opacity: 0.1;
        transition: 0.2s;
        position: absolute;
        right: 0;
        top: 0;
      }
      .name-photo {
        height: @photoWidth;
        padding-left: @photoWidth;
        position: relative;
        z-index: 2;
        .photo {
          width: @photoWidth;
          height: @photoWidth;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .username{
          padding: 8px 0 0 20px;
          h1 {
            font-family: Georgia, 宋体;
            font-weight: bold;
          }
          * {
            margin: 0;
          }
        }
      }
      .item-info {
        padding-top: 20px;
        position: relative;
        z-index: 2;
        p:first-child {
          padding-bottom: 10px;
        }
        * {
          margin: 0;
        }
      }
      .username,
      .item-info {
        .silver,
        .black {
          transition: 0.3s;
        }
      }
      &:hover {
        .back-mask {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
        .username,
        .item-info {
          .silver {
            color: #FFF;
            opacity: 0.6;
          }
          .black {
            color: #FFF;
          }
        }
      }
    }
    /*.pagination-style {
      margin-top: -16px;
      float: right;
    }*/
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .teama-card-list {
    .card-item {
      overflow: hidden;
      height: 330px;
      background-color: #FFF;
      padding: 30px;
      cursor: pointer;
      margin-bottom: 30px;
      position: relative;
      .back-logo {
        width: @logoWidth;
        height: @logoWidth;
        position: absolute;
        bottom: -30px;
        right: -30px;
      }
      .back-mask {
        width: @maskWidth;
        height: @maskWidth;
        opacity: 0.1;
        transition: 0.2s;
        position: absolute;
        right: 0;
        top: 0;
      }
      .name-photo {
        height: @photoWidth;
        padding-left: @photoWidth;
        position: relative;
        z-index: 2;
        .photo {
          width: @photoWidth;
          height: @photoWidth;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .username{
          padding: 8px 0 0 20px;
          h1 {
            font-family: Georgia, 宋体;
            font-weight: bold;
          }
          * {
            margin: 0;
          }
        }
      }
      .item-info {
        padding-top: 20px;
        position: relative;
        z-index: 2;
        p:first-child {
          padding-bottom: 10px;
        }
        * {
          margin: 0;
        }
      }
      .username,
      .item-info {
        .silver,
        .black {
          transition: 0.3s;
        }
      }
      &:hover {
        .back-mask {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
        .username,
        .item-info {
          .silver {
            color: #FFF;
            opacity: 0.6;
          }
          .black {
            color: #FFF;
          }
        }
      }
    }
    .pagination-style {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/teamAll.vue